"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertor = exports.taskFromOperationNode = void 0;
const common_1 = require("@finley-technologies/common");
const converterUtils_1 = require("../converterUtils");
const types_1 = require("./types");
const taskToOperationNode = (task) => {
    const { srcArtifactSlug: _unused1, otherArtifactSlugs: _unused2, ...nodeConfiguration } = task;
    return (0, converterUtils_1.newOperationNode)(types_1.nodeType, nodeConfiguration);
};
const taskFromOperationNode = ({ srcNodes, operationNode, }) => {
    const { configuration } = operationNode;
    (0, common_1.finleyAssert)(srcNodes.length >= 1, `stack node has [${srcNodes.length}] src nodes`);
    const [srcArtifactSlug, ...otherArtifactSlugs] = srcNodes.map((srcNode) => (0, converterUtils_1.getSrcArtifactSlug)(srcNode));
    return {
        ...configuration,
        srcArtifactSlug,
        otherArtifactSlugs,
    };
};
exports.taskFromOperationNode = taskFromOperationNode;
exports.convertor = {
    operation: 'stack',
    nodeType: types_1.nodeType,
    taskToOperationNode,
    taskFromOperationNode: exports.taskFromOperationNode,
    getInputSlugs: (task) => [task.srcArtifactSlug, ...task.otherArtifactSlugs],
    toTransformation: (task, resolveDef) => {
        const { srcArtifactSlug, otherArtifactSlugs, ensureUniqueFields } = task;
        const inputSlugs = [srcArtifactSlug, ...otherArtifactSlugs];
        const inputTapeDefinitionResults = inputSlugs.map((slug) => resolveDef(slug));
        const errors = [];
        const inputTapeDefinitions = inputTapeDefinitionResults.map((tape) => {
            if (!tape.isValid) {
                errors.push(...tape.errors);
                return null;
            }
            if (!tape.data) {
                errors.push('Stack operation requires sanitized tapes as inputs. Are you using the correct tapes?');
                return null;
            }
            return tape.data;
        });
        if (errors.length) {
            return {
                isValid: false,
                errors,
            };
        }
        const validTapeDefinitions = inputTapeDefinitions.filter(common_1.typeguards.isNotNullOrUndefined);
        return {
            isValid: true,
            data: {
                operation: 'stack',
                srcDataTape: validTapeDefinitions[0],
                otherDataTapes: validTapeDefinitions.slice(1),
                ensureUniqueFields,
            },
        };
    },
};
//# sourceMappingURL=converter.js.map